<div data-test="UejAiRoF" class="file-upload">
  <label data-test="SfMMTug2" class="form-group__label">{{ label }}</label>
  <label data-test="JlKOVNbX" [ngClass]="labelClasses">
    <button
      data-test="XuVyrc7q"
      *ngIf="imageSrc && hasOwnImage"
      (click)="removeImage(); $event.preventDefault()"
      class="input-file__delete"
      type="button"
      data-upload="remove"
    >
      <span data-test="SOIYdZNL" class="icon text-white">
        <svg data-test="G88ZtbnC" class="icon__icon-delete" width="30" height="30">
          <use xlink:href="#icon-delete"></use>
        </svg>
      </span>
    </button>
    <input
      data-test="8wfPvXbJ"
      #fileInput
      type="file"
      [accept]="accept"
      (change)="fileChange(fileInput, dragDropDirective)"
    />
    <div
      data-test="JkyYCDqL"
      class="file-upload__logo img-square"
      *ngIf="imageSrc"
      [style.background-image]="'url(' + imageSrc + ')'"
    ></div>
    <div
      data-test="ukGSVLjO"
      class="input-file__inner input-file__inner_group"
      mdDragDrop
      #dragDropDirective="mdDragDrop"
      [pattern]="accept"
      [canRead]="canRead"
      (errorHandler)="fileDropError($event)"
      (readHandler)="fileDropRead($event)"
      (dropHandler)="fileDrop($event)"
    >
      <span data-test="Og2fkchr" class="icon">
        <svg data-test="jvn_tmit" class="icon__icon-upload-2" width="40" height="40">
          <use xlink:href="#icon-upload-2"></use>
        </svg>
      </span>
      <span data-test="WKfx9fzI" class="input-file__text">
        <b data-test="hMmBy8EK">Drag & drop to upload</b>
      </span>
      <span data-test="pIadES5R" class="text-xs">
        or&nbsp;
        <span data-test="BRqYm5x-" class="link">browse</span>
        to choose a files
      </span>
    </div>
  </label>
</div>
